/* Preserve bookmarked links from the former hash-routed storefront. */
(function () {
  'use strict';
  if (!/^#\//.test(location.hash)) return;
  var route = location.hash.slice(2), target = null, match;
  var pages = ['about', 'shipping', 'contact', 'resources', 'samples', 'quote', 'printers', 'retailers', 'organizations', 'quick-order', 'register'];
  if (!route) target = '/';
  else if (route === 'shop') target = '/collections/bns-catalogue';
  else if (route === 'cart') target = '/cart';
  else if (route === 'account' || route === 'signin') target = '/account';
  else if (route === 'checkout') target = '/cart';
  else if ((match = route.match(/^(?:c|lines)\/([\w-]+)$/))) target = '/collections/' + match[1];
  else if ((match = route.match(/^p\/([\w-]+)$/))) {
    resolveProduct(match[1]);
    return;
  }
  else if ((match = route.match(/^colour(?:\/(.*))?$/))) {
    var colour = match[1] || '';
    try { colour = decodeURIComponent(colour); } catch (error) { /* Keep malformed legacy text searchable. */ }
    target = '/pages/colour' + (colour ? '?colour=' + encodeURIComponent(colour) : '');
  }
  else if (pages.indexOf(route.split('?')[0]) !== -1) target = '/pages/' + route;
  if (target) navigate(target);

  function navigate(target) {
    var destination = new URL(target, location.origin);
    var previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
    location.replace(destination.toString());
  }

  // Old style-number bookmarks resolve against current Shopify product records.
  // The header supplies this data through Liquid; no handle map is frozen here.
  function resolveProduct(style) {
    async function ready() {
      var node = document.querySelector('[data-bns-search-catalogue]');
      var form = document.querySelector('[data-bns-instant-search]');
      var seen = new Set();
      try {
        while (node) {
          var data = JSON.parse(node.textContent);
          var found = (data.products || []).find(function (product) {
            return String(product.style).toLowerCase() === style.toLowerCase();
          });
          if (found) { navigate(found.url); return; }
          if (!data.next || seen.has(data.next) || !form) break;
          seen.add(data.next);
          var next = new URL(data.next, location.origin);
          if (next.origin !== location.origin) break;
          next.searchParams.set('section_id', form.dataset.sectionId);
          var response = await fetch(next, { credentials: 'same-origin' });
          if (!response.ok) break;
          node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-bns-search-catalogue]');
        }
      } catch (error) { /* A native search remains usable when lookup is unavailable. */ }
      navigate('/search?type=product&q=' + encodeURIComponent(style));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
    else ready();
  }
}());
